import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Notes extends Component {

  static get propTypes() {
    return {
      color: PropTypes.string,
    };
  }

  constructor() {
    super();
    this.state = {
      isSmallScreen: false,
      isSidebarShow: false,
      config: [],
    };
  }

  componentDidMount() {

  }

  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" id="prefix__icon_s_notes" width="30" height="30" viewBox="0 0 30 30">
        <g id="prefix__Group_95" data-name="Group 95" transform="translate(4.5 4.5)">
            <path id="prefix__Path_129" d="M199.08 358.347a.751.751 0 0 1 .751-.75h13.635a.75.75 0 1 1 0 1.5h-13.635a.749.749 0 0 1-.751-.75z" className="prefix__cls-1" data-name="Path 129" transform="translate(-195.705 -351.597)"/>
            <path id="prefix__Path_130" d="M199.08 368.347a.751.751 0 0 1 .753-.75h8.619a.75.75 0 1 1 0 1.5h-8.619a.75.75 0 0 1-.753-.75z" className="prefix__cls-1" data-name="Path 130" transform="translate(-195.705 -357.847)"/>
            <g id="prefix__Group_94" data-name="Group 94">
                <path id="prefix__Path_131" d="M226.922 343.1h3.717a1.5 1.5 0 0 1 1.5 1.5v10.125a.75.75 0 0 0 1.5 0V344.6a3 3 0 0 0-3-3h-3.717a.75.75 0 0 0 0 1.5z" className="prefix__cls-2" data-name="Path 131" transform="translate(-212.638 -341.597)"/>
                <path id="prefix__Path_132" d="M211.034 357.206a.749.749 0 0 0-1.046-.173l-4.422 3.169v-4.464a.316.316 0 0 1 .316-.315h1.066a.75.75 0 0 0 0-1.5h-1.066a1.817 1.817 0 0 0-1.816 1.815v4.985h-10.987a1.5 1.5 0 0 1-1.5-1.5v-14.629a1.5 1.5 0 0 1 1.5-1.5h3.746a.75.75 0 1 0 0-1.5h-3.746a3 3 0 0 0-3 3v14.631a3 3 0 0 0 3 3h11.627a2.106 2.106 0 0 0 1.115-.357l5.042-3.613a.749.749 0 0 0 .171-1.049z" className="prefix__cls-2" data-name="Path 132" transform="translate(-190.081 -341.597)"/>
            </g>
            <path id="prefix__Path_133" d="M217.08 343.1a1.5 1.5 0 1 0-2.25 1.292v.958a.75.75 0 0 0 1.5 0v-.958a1.494 1.494 0 0 0 .75-1.292z" className="prefix__cls-2" data-name="Path 133" transform="translate(-205.08 -341.596)"/>
        </g>
        <path id="prefix__Rectangle_39" d="M0 0H30V30H0z" data-name="Rectangle 39" style={{ fill: 'none' }}/>
    </svg>
    );
  }
}

export default Notes;



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/containers/App/components/Layout/components/Notes/index.js
 **/